import { useMutation, useQuery } from '@tanstack/react-query';
import useTranslate from '../../Hooks/useTranslate';
import notify from '../../Style-guide/ToastMessage';
import { deleteData, getData, sendData, updateData } from '../fetchers';

/// Organizer Authentication
export const useOrganizersLoginMutation = () =>
  useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      sendData('organizers/login', data, params, queryParams),
  });

export const useOrganizersLogoutMutation = () =>
  useMutation({ mutationFn: (data) => sendData('organizers/logout', data) });

/// Organizer Api
export const useGetOrganizerQuery = (params) =>
  useQuery({
    queryKey: ['organizers', params],
    queryFn: () =>
      'enabled' in params && !params.enabled
        ? null
        : getData('organizers/:id', params?.params),

    retry: 0,
    select: (data) => data?.data,
    ...params,
    enabled: false,
  });

export const useUpdateOrganizerMutation = () => {
  const tr = useTranslate();

  return useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      updateData('organizers/:id', data, params, queryParams),
    onSuccess: (data) => notify.success(tr(data?.translationKey) || data?.message),
  });
};

export const useCreateOrganizerMutation = () =>
  useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      sendData('organizers', data, params, queryParams),
    onSuccess: (data) => notify.success(data?.message),
  });

export const useDeleteOrganizerMutation = () =>
  useMutation({
    mutationFn: ({ data, params, queryParams }) =>
      deleteData('organizers', data, params, queryParams),
    onSuccess: (data) => notify.success(data?.message),
  });
